<template>
  <div>
    <el-row :gutter="16" type="flex" align="middle" justify="space-between">
      <el-col :span="4">
        <el-input v-model="crawlerVersion" clearable placeholder="输入采集日期">
        </el-input>
      </el-col>
      <el-col :span="4">
        <el-input v-model="keyword" clearable placeholder="输入检索词">
        </el-input>
      </el-col>
      <el-col :span="4">
        <el-input v-model="authorName" clearable placeholder="输入用户昵称">
        </el-input>
      </el-col>
      <el-col :span="4">
        <el-input v-model="articleContent" clearable placeholder="输入标题">
        </el-input>
      </el-col>
      <el-col :span="4">
        <el-select
          v-model="whether"
          clearable
          style="width: 100%"
          placeholder="请选择是否新增"
        >
          <el-option label="非新增" :value="0"></el-option>
          <el-option label="新增" :value="1"></el-option>
        </el-select>
      </el-col>
    </el-row>
    <el-row
      :gutter="16"
      style="margin-top: 16px"
      type="flex"
      justify="center"
      align="middle"
    >
      <el-col :span="2" :offset="8">
        <el-button icon="el-icon-search" @click="searchPageData"
          >搜索</el-button
        >
      </el-col>
      <el-col :span="2">
        <el-badge v-model="selectedCount" class="item">
          <el-button @click="showSelected" alt="">查看选中</el-button>
        </el-badge>
      </el-col>
      <el-col :span="4">
        <el-button-group>
          <el-button icon="el-icon-delete" @click="clearSelected" alt=""
            >取消选中</el-button
          >
          <el-button icon="el-icon-download" @click="exportSelectedData" alt=""
            >下载</el-button
          >
        </el-button-group>
      </el-col>
      <el-col :span="8" style="color: #999; font-size: 14px; text-align: right">
        <p>1、有选中数据时，优先导出选中数据</p>
        <p>2、无选中数据时，导出当前筛选条件下的数据</p>
      </el-col>
    </el-row>
    <el-row style="padding-top: 16px">
      <el-pagination
        background
        @current-change="queryGoodsPage"
        layout="total, prev, pager, next"
        :total="totalItems"
        :page-size="pageSize"
      >
      </el-pagination>
    </el-row>
    <el-row style="padding-top: 16px">
      <el-table
        ref="dataTable"
        :data="users"
        style="width: 100%"
        @select="handleSelectionChange"
        @select-all="handleSelectAll"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column prop="searchKeyword" label="日期/关键词">
          <template scope="scope">
            {{ scope.row.version }} / {{ scope.row.keywords }}
          </template>
        </el-table-column>
        <el-table-column prop="_id" label="主键"> </el-table-column>
        <el-table-column prop="pic_link" label="地址"> </el-table-column>
        <el-table-column prop="title" label="标题"> </el-table-column>
        <el-table-column prop="image" label="图片地址">
          <template scope="scope">
            <img
                :src="scope.row.image"
                width="70"
                height="70"
                class="head_pic"
            />
          </template>
        </el-table-column>
        <el-table-column prop="source" label="来源"> </el-table-column>
        <el-table-column prop="creator_id" label="用户ID"> </el-table-column>
        <el-table-column prop="creator" label="用户昵称"> </el-table-column>
        <el-table-column prop="creator_link" label="用户主页">
        </el-table-column>
        <el-table-column prop="creator_headportrait" label="用户头像">
          <template scope="scope">
            <img v-if="scope.row.creator_headportrait !== ''"
                :src="scope.row.creator_headportrait"
                width="70"
                height="70"
                class="head_pic"
            />
          </template>
        </el-table-column>
      </el-table>
    </el-row>
  </div>
</template>
<script>
const axios = require("axios");
const _ = require("lodash");
export default {
  name: "pinterestImage",
  data() {
    return {
      users: [],
      whether: null,
      keyword: "",
      authorName: "",
      articleContent: "",
      crawlerVersion: null,
      currentPage: 1,
      totalItems: 0,
      pageSize: 50,
      selectedCount: 0,
    };
  },
  methods: {
    clearSelected() {
      let _this = this;
      axios
        .get("/api/soci/clear/data?platform=pinterest&type=image")
        .then((content) => {
          if (content.data.status.code === "0") {
            _this.selectedCount = 0;
            _this.loadItemInfo(1);
          }
        });
    },
    countSelected() {
      let _this = this;
      axios
        .get("/api/soci/count/data?platform=pinterest&type=image")
        .then((content) => {
          if (content.data.status.code === "0") {
            _this.selectedCount = content.data.data;
          }
        });
    },
    showSelected() {
      var _this = this;
      axios.get("/api/pinterest/show/selected/image").then((content) => {
        if (content.data.status === 0) {
          _this.users = content.data.data;
          _this.totalItems = content.data.total;
          _this.$nextTick(() => {
            _this.users.forEach((row) => {
              console.log(row);
              if (row.selected === true) {
                _this.$refs.dataTable.toggleRowSelection(row, true);
              }
            });
          });
        }
      });
    },
    exportSelectedData() {
      let para = "";
      if (this.crawlerVersion != null) {
        para += "&crawlerVersion=" + this.crawlerVersion;
      }

      if (this.keyword !== "") {
        para += "&keyword=" + this.keyword;
      }
      if (this.whether !== "") {
        para += "&whether=" + this.whether;
      }
      if (this.authorName !== "") {
        para += "&authorName=" + this.authorName;
      }
      if (this.articleContent !== "") {
        para +=
          "&articleContent=" +
          encodeURIComponent(this.articleContent.replace(/(^\s*)|(\s*$)/g, ""));
      }
      if (!this.selectedCount || this.selectedCount === 0) {
        this.$message("导出全部数据需要较长时间，请勿关闭相应窗口。");
        setTimeout(() => {
          window.open("/api/pinterest/export/selected/image?" + para);
        }, 1000);
      } else {
        window.open("/api/pinterest/export/selected/image?" + para);
      }
    },
    handleSelectAll(selection) {
      let ids =
        selection.length > 0
          ? selection.map((item) => {
              return item._id;
            })
          : this.users.map((item) => {
              return item._id;
            });
      axios
        .post(
          selection.length > 0
            ? "/api/soci/pushToCacheMulti"
            : "/api/soci/removeFromCacheMulti",
          {
            platform: "pinterest",
            type: "image",
            ids: ids,
          }
        )
        .then((content) => {
          if (content.data.status === 0) {
            console.log("dfsdfs");
          }
          this.countSelected();
        });

      // this.countSelected();
    },
    handleSelectionChange(selection, row) {
      console.log(selection);
      const existItem = _.find(selection, { _id: row["_id"] });
      if (existItem !== undefined) {
        axios
          .get(
            "/api/soci/pushToCache?platform=pinterest&type=image&id=" +
              row["_id"]
          )
          .then((content) => {
            if (content.data.status === 0) {
              console.log("dfsdfs");
            }
            this.countSelected();
          });
      } else {
        axios
          .get(
            "/api/soci/removeFromCache?platform=pinterest&type=image&id=" +
              row["_id"]
          )
          .then((content) => {
            if (content.data.status === 0) {
              console.log("dfsdfs");
            }
            this.countSelected();
          });
      }
      // this.countSelected()
    },
    searchPageData() {
      this.currentPage = 1;
      this.loadItemInfo(1);
    },
    queryGoodsPage(pageNum) {
      this.currentPage = pageNum;
      this.loadItemInfo(pageNum);
    },
    loadItemInfo(pageNum) {
      var _this = this;
      let para = "";
      if (this.crawlerVersion != null) {
        para += "&crawlerVersion=" + this.crawlerVersion;
      }

      if (this.keyword !== "") {
        para += "&keyword=" + this.keyword;
      }
      if (this.whether !== "") {
        para += "&whether=" + this.whether;
      }
      if (this.authorName !== "") {
        para += "&authorName=" + this.authorName;
      }
      if (this.articleContent !== "") {
        para +=
          "&articleContent=" +
          encodeURIComponent(this.articleContent.replace(/(^\s*)|(\s*$)/g, ""));
      }

      axios
        .get(
          "/api/pinterest/image?currentPage=" + pageNum + "&pageSize=50" + para
        )
        .then((content) => {
          if (content.data.status === 0) {
            _this.users = content.data.data;
            _this.totalItems = content.data.total;
            _this.$nextTick(() => {
              _this.users.forEach((row) => {
                if (row.selected === true) {
                  _this.$refs.dataTable.toggleRowSelection(row, true);
                }
              });
            });
          }
        });
    },
  },
  mounted() {
    this.loadItemInfo(1);
    this.countSelected();
  },
};
</script>
